var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-dialog', _vm._b({ directives: [{ name: "loading", rawName: "v-loading", value: _vm.advertiser.loading, expression: "advertiser.loading" }], attrs: { "visible": _vm.visible }, on: { "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      } } }, 'el-dialog', _vm.dialogAttrs, false), [_c('advertiser-info-form', { ref: "form", on: { "cancel": _vm.handleCancel, "save-success": _vm.handleSuccess } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };